import customAxios from "./axiosConfig";

const ProductService = {
  list: function (params) {
    return customAxios.get(window.Urls["product-list"](),  { params: params });
  },
  listForImport (params) {
    const api_url = window.Urls['product_get_product_list_for_import']();
    return customAxios.get(api_url, { params: params });
  },
  create: function(data) {
    var url = window.Urls["product-list"]();
    const config = {
        headers: { 'content-type': 'multipart/form-data' },
    };
    const getFormData = object => Object.keys(object).reduce((formData, key) => {
            formData.append(key, object[key]);
            return formData;
        }, new FormData());
    return customAxios.post(url, getFormData(data), config).then(function(response){
        if (window.mixpanel) {
          window.mixpanel.track("Product: create");
        }
        return response;
    });
  },
  update: function (pk, data) {
    var url = window.Urls["product-detail"](pk);
    return customAxios.put(url, data)
        .then(function(response){
          if (window.mixpanel) {
            window.mixpanel.track("Product: edit");
          }
          return response;
        });
  },
  destroy: function (pk) {
    var url = window.Urls["product-detail"](pk);
    return customAxios.delete(url)
        .then(function(response){
          if (window.mixpanel) {
            window.mixpanel.track("Product: delete");
          }
          return response;
        });

  },
  report(params) {
    var api_url = window.Urls["product_report"]();
    return customAxios.get(api_url, {params: params});
  }
};

export default ProductService ;